module.exports = __webpack_public_path__ + "static/media/6-item-b.20ac7206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/6-item-b.jpg
// module id = 1202
// module chunks = 33